import React, {useEffect, useLayoutEffect} from "react";
import styled from "styled-components";
import PullToRefresh from "react-simple-pull-to-refresh";
import {useLocation, useNavigate, useNavigationType} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {
	fetchDetailBranchPageScroll,
	fetchBranchVoucherInfo,
	updateVoucherInfo,
	updateBranchVoucherInfoList
} from "redux/slices/sales/salesSlice";

import {isBranchPermission} from "utils/define";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "../period/SummaryInfo";
import BranchDetailList from "./BranchDetailList";
import PullToRefreshing from "components/common/PullToRefreshing";



/**
 * [전지점 이용권 종류별 매출]
 */

export const BranchDetail = (props) => {
	const dispatch = useDispatch();
	const location =  useLocation();
	const navigate = useNavigate();
	const navigationType = useNavigationType();

	let {
		searchPartner,
		searchBranch,
		searchDate,
		searchPeriodType,
		searchFilter,
		data,
		isLoading,
		isError
	} = useSelector(state => state.sales.branchVoucherInfo);
	const partnerInfo = useSelector(state => state.partner);
	const salesInfo = useSelector(state => state.sales);

	useLayoutEffect(() => {
		return () => {
			dispatch(fetchDetailBranchPageScroll("store"));
		};
	}, []);

	useEffect(() => {
		if(!searchPartner) {
			dispatch(fetchBranchVoucherInfo({
				searchPartner : partnerInfo.seqPartner,
				searchDate : salesInfo.searchDate,
				searchPeriodType : salesInfo.searchPeriodType
			}));
		}
		if(!isBranchPermission(partnerInfo)) {
			navigate("/sales");
			return null;
		}
	}, []);

	useEffect(() => {
		const isUpdate = (
			!data || navigationType != "POP" || (
				searchPartner != data.searchInfo.searchPartner ||
				searchBranch != data.searchInfo.searchBranch ||
				searchDate != data.searchInfo.searchDate ||
				searchPeriodType != data.searchInfo.searchPeriodType ||
				searchFilter != data.searchInfo.searchFilter
			)
		);
		if(isUpdate) eventHandler.update();
	}, [searchPartner, searchBranch, searchDate, searchPeriodType, searchFilter]);

	const eventHandler = {
		update : () => {
			dispatch(updateVoucherInfo({
				searchPartner : searchPartner,
				searchBranch : searchBranch,
				searchDate : searchDate,
				searchPeriodType : searchPeriodType,
				searchFilter : searchFilter
			}, fetchBranchVoucherInfo, "branchVoucherInfo"));
		},
		changeDate : (date) => {
			dispatch(fetchBranchVoucherInfo({
				searchDate : date
			}));
		},
		pullToRefresh: () => {
			return new Promise((resolve) => {
				setTimeout(() => {
					eventHandler.update();
					dispatch(updateBranchVoucherInfoList(false));
					resolve();
				}, 700);
			});
		}
	};

	const render = () => {
		return (
			<PullToRefresh
				onRefresh={eventHandler.pullToRefresh}
				resistance={2}
				pullingContent={<></>}
				refreshingContent={<PullToRefreshing />}
			>
				<MainLayout
					withHeader={true}
					headerProps={{
						withBackButton : true,
						centerTitle : "전 지점 이용권 종류별 매출"
					}}
					backgroundColor="white"
					withBottomTab={false}
				>
					<SummaryInfo
						mode={searchPeriodType}
						date={searchDate}
						data={data}
						isLoading={isLoading}
						isError={isError}
						onChange={eventHandler.changeDate}
						onRefresh={eventHandler.update}
					/>
					<BranchDetailList />
				</MainLayout>
			</PullToRefresh>
		);
	};

	return render();
};

export default BranchDetail;